import uuid from 'draft-js/lib/uuid';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';

const deleteDealForV2Customer = (treeId, dealId, callback, errorCallback) => {
  return async (dispatch) => {
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      const token = await user.getIdToken();
      try {
        const response = await axios.delete(
          `/ads/discovery-tree/${treeId}/deals/${dealId}`,
          {
            params: {
              'request-id': uuid(),
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.status === 200) {
          if (typeof callback === 'function') callback();
        } else {
          if (typeof errorCallback === 'function')
            errorCallback(response?.data);
        }
      } catch (e) {
        console.log(e);
        if (typeof errorCallback === 'function')
          errorCallback(e?.response?.data?.message);
      }
      unsubscribe();
    });
  };
};

export default deleteDealForV2Customer;
